import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';
import { notifyPermissionDenied } from '../core/handleCallableError';

export const getAuctionUpdates = async (auctionIds) => {
  try {
    const result = await httpsCallable(functions, 'getAllAuctionsReloadableNewV2')({ auctionIds });
    return result.data;
  } catch (error) {
    notifyPermissionDenied(error);
    throw error;
  }
};

export const getAllAuctions = async (
  sortBy,
  isAscending,
  limit = 10
) => {
  // Identidad, grupos y bans se derivan exclusivamente de Auth en backend.
  const data = { sortBy, isAscending, limit };
  
  const getAllAuctionsFn = httpsCallable(
    functions,
    'getAllAuctionsReloadableNewV2'
  );
  try {
    const result = await getAllAuctionsFn(data);
    return result.data;
  } catch (error) {
    console.error('Error al obtener las subastas:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};

export const reloadedGetAllAuctions = async (
  lastVisible,
  limit,
  sortBy,
  isAscending
) => {
  const data = {
    lastVisible,
    limit,
    sortBy,
    isAscending,
  };
  
  const getAllAuctionsFn = httpsCallable(
    functions,
    'getAllAuctionsReloadableNewV2'
  );
  try {
    const result = await getAllAuctionsFn(data);
    return result.data;
  } catch (error) {
    console.error('Error al obtener las subastas:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
